import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { GlobalVariable } from '../helpers/settings';
import { Result } from '../models/general';
import { TransactionModel, TransactionConfig } from '../models/transaction-model';
import { RefreshVerificationService } from './refresh-verification.service';
export interface PaginationData {
	docs: TransactionModel[];
	total: number;
	limit: number;
	page: number;
	pages: number;
}

@Injectable({
	providedIn: 'root'
})
export class TransactionModelService {
	readonly BASE_URL = `${GlobalVariable.server.host}/transaction-model`;

	constructor(private httpClient: HttpClient, private refreshVerifService: RefreshVerificationService) {}

	find(
		fromAppComponent: boolean,
		route: string,
		projectId: string,
		attributes: string = null
	): Observable<TransactionModel[]> {
		let params;
		if (fromAppComponent) {
			params = new HttpParams()
				.set('fromAppComponent', fromAppComponent)
				.set('componentRoute', route)
				.set('projectId', projectId);
		} else {
			params = new HttpParams().set('fromAppComponent', fromAppComponent);
		}
		// params = params.set('attributes', attributes ?? null);
		return this.refreshVerifService.buidResult(
			this.httpClient.get<TransactionModel[]>(`${this.BASE_URL}/find`, { params })
		);
	}
	findByProject(projectId: string, fromAppComponent: boolean, route: string): Observable<TransactionModel[]> {
		let params;
		if (fromAppComponent) {
			params = new HttpParams()
				.set('fromAppComponent', fromAppComponent)
				.set('componentRoute', route)
				.set('projectId', projectId);
		} else {
			params = new HttpParams().set('fromAppComponent', fromAppComponent);
		}
		return this.refreshVerifService.buidResult(
			this.httpClient.get<TransactionModel[]>(`${this.BASE_URL}/find-by-project/${projectId}`, { params })
		);
	}

	findById(id: string, fromAppComponent: boolean, route: string, projectId: string): Observable<TransactionModel> {
		let params;
		if (fromAppComponent) {
			params = new HttpParams()
				.set('fromAppComponent', fromAppComponent)
				.set('componentRoute', route)
				.set('projectId', projectId);
		} else {
			params = new HttpParams().set('fromAppComponent', fromAppComponent);
		}
		return this.refreshVerifService.buidResult(
			this.httpClient.get<TransactionModel>(`${this.BASE_URL}/find-by-id/${id}`, { params })
		);
	}

	create(transactionModel: Partial<TransactionModel>): Observable<Result> {
		return this.refreshVerifService.buidResult(
			this.httpClient.post<Result>(`${this.BASE_URL}/create`, transactionModel)
		);
	}

	edit(transactionModel: Partial<TransactionModel>): Observable<Result> {
		return this.refreshVerifService.buidResult(
			this.httpClient.put<Result>(`${this.BASE_URL}/edit`, transactionModel)
		);
	}

	delete(transactionModelId: string): Observable<Result> {
		return this.refreshVerifService.buidResult(
			this.httpClient.delete<Result>(`${this.BASE_URL}/delete/${transactionModelId}`)
		);
	}

	updateTransactionConfig(data: {
		transactionModel: string;
		transactionConfig: TransactionConfig;
	}): Observable<Result> {
		return this.refreshVerifService.buidResult(
			this.httpClient.put<Result>(`${this.BASE_URL}/transaction-config/${data.transactionModel}`, data)
		);
	}
	archive(transactionModelId: string): Observable<Result> {
		return this.refreshVerifService.buidResult(
			this.httpClient.delete<Result>(`${this.BASE_URL}/archive/${transactionModelId}`)
		);
	}
	isUsed(transactionModelId: string): Observable<Result> {
		return this.refreshVerifService.buidResult(
			this.httpClient.get<Result>(`${this.BASE_URL}/if-is-Used/${transactionModelId}`)
		);
	}
}
